import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hola! Soy <span className="purple">Federico Kaprielian, </span>
            de <span className="purple"> Mendoza,Argentina.</span>
            <br />
            Actualmente trabajo como Desarrollador de Software en COLSA, y
            estudio la Tecnicatura en Desarrollo de Software en el Instituto
            Santo Domingo.
            <br />
            Además del desarrollo, disfruto de varias actividades en mi tiempo
            libre, como:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Reunirme con amigos
            </li>
            <li className="about-activity">
              <ImPointRight /> Practicar Karate
            </li>
            <li className="about-activity">
              <ImPointRight /> Jugar Videojuegos
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
